import { useEffect, useState } from "react";
import { Trophy, TrendingDown } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtAmt = (a) => (a >= 10 ? `$${Math.round(a)}` : `$${a.toFixed(2)}`);

const WinCard = ({ w }) => {
  const up = (w.amount ?? 0) >= 0;
  return (
    <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-[#10141f]/90 px-4 py-3">
      <span className={`grid place-items-center w-10 h-10 rounded-full shrink-0 border ${up ? "bg-[#089981]/15 border-[#089981]/30" : "bg-[#F23645]/15 border-[#F23645]/30"}`}>
        {up ? <Trophy className="w-5 h-5 text-[#089981]" /> : <TrendingDown className="w-5 h-5 text-[#F23645]" />}
      </span>
      <div className="min-w-0">
        <div className="flex items-baseline gap-2 flex-wrap">
          <span className="font-mono font-black text-white text-sm">{w.name}</span>
          <span className={`font-mono font-black text-lg ${up ? "text-[#089981]" : "text-[#F23645]"}`}>{up ? "+" : "−"}{fmtAmt(Math.abs(w.amount))}</span>
          <span className="font-mono text-white/45 text-[11px]">{up ? "winning" : "losing"} session · {w.wins || 0}W / {w.losses || 0}L</span>
        </div>
        <p className="font-mono text-[10px] uppercase tracking-wider text-white/40 truncate">
          {(w.strategy || "VTS Trade").replace(/^Arcade /, "")}
        </p>
      </div>
    </div>
  );
};

const RecentWinsTicker = () => {
  const [wins, setWins] = useState([]);
  useEffect(() => {
    let dead = false;
    const load = () => axios.get(`${API}/public/recent-wins?limit=14`)
      .then((r) => { if (!dead) setWins(r.data?.wins || []); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { dead = true; clearInterval(t); };
  }, []);
  if (wins.length < 3) return null;
  const loop = [...wins, ...wins];
  return (
    <div data-testid="recent-wins-ticker" className="flex flex-col">
      <style>{`
        @keyframes rwScrollUp { 0% { transform: translateY(0); } 100% { transform: translateY(-50%); } }
        .rw-track { animation: rwScrollUp ${Math.max(18, wins.length * 3)}s linear infinite; }
        .rw-viewport:hover .rw-track { animation-play-state: paused; }
      `}</style>
      <div className="flex items-center gap-2 mb-4">
        <span className="w-2.5 h-2.5 rounded-full bg-[#089981] animate-pulse" />
        <h2 className="font-mono font-black tracking-[0.18em] text-white/80 text-base md:text-lg">RECENT SESSIONS</h2>
        <span className="ml-auto font-mono text-[9px] text-white/35">wins AND losses · live from real settled contracts</span>
      </div>
      <div className="rw-viewport relative h-[380px] overflow-hidden rounded-2xl border border-white/10 bg-[#0d1119]">
        <div className="pointer-events-none absolute inset-x-0 top-0 h-12 bg-gradient-to-b from-[#0d1119] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-[#0d1119] to-transparent z-10" />
        <div className="rw-track space-y-2 p-3">
          {loop.map((w, i) => <WinCard key={i} w={w} />)}
        </div>
      </div>
      <p className="mt-2 font-mono text-[9px] text-white/35 text-center">
        daily session totals from real settled contracts · names are pseudonyms unless publicly claimed · past results never guarantee future ones
      </p>
    </div>
  );
};

export default RecentWinsTicker;
